import styled from 'styled-components';

export const BackButton = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  color: #4c7cfd;
  font-family: 'TTCommons';
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 11px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;
